import React from "react";
import "./contact-us-hero.scss";
import arrowLeft from "../../../assets/images/arrow-left.svg";
import { useTranslation } from "react-i18next";
function AboutUsHero(props) {
  const {t} = useTranslation();
  return (
    <div className="contact-us-hero d-flex align-items-center position-relative overflow-hidden animate__animated animate__fadeIn animate__delay-1s">
      <div className="container px-lg-5">
        <div className="row px-lg-5">
          <div className="col-md-6 col-lg-8 text-white text-start">
            <h2>{t('contact-us.banner-text')}</h2>
          </div>
        </div>
      </div>
      <img src={arrowLeft} className="left-arrow d-none d-sm-block position-absolute" alt="styling arrow right" style={{right:0}}/>
    </div>
  );
}

export default AboutUsHero;
